import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AdminToolbar from '../../Toolbar/AdminToolbar';
import EditorToolbar from '../../Toolbar/EditorToolbar';
import ManageCategories from './ManageCategories';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ManageCategoriesWrapper = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserFromCookie = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });
        const { user, username } = res.data;
        if (username && (user === 'Admin' || user === 'Editor')) {
          setUserType(user);
          setUsername(username);
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Error checking login:', err);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    getUserFromCookie();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  return (
    <>
     
      {userType === 'Admin' && (
            <>
            <AdminToolbar/>
            <ManageCategories user={userType}/>
            </>
          )}
      {userType === 'Editor' && (
            <>
            <EditorToolbar/>
            <ManageCategories user={userType}/>
            </>
          )}
    </>
  );
};

export default ManageCategoriesWrapper;
